export default {
    actions: {
        type: Array,
        default: undefined
    }, 
    animation: {
        type: [Boolean, Object],
        default: undefined
    }, 
    buttonLayout: {
        type: String,
        default: undefined
    }, 
    closable: {
        type: Boolean,
        default: undefined
    }, 
    content: {
        type: String,
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    maxHeight: {
        type: Number,
        default: undefined
    }, 
    maxWidth: {
        type: Number,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    minHeight: {
        type: Number,
        default: undefined
    }, 
    minWidth: {
        type: Number,
        default: undefined
    }, 
    modal: {
        type: [Boolean, Object],
        default: undefined
    }, 
    title: {
        type: [String, Boolean],
        default: undefined
    }, 
    visible: {
        type: Boolean,
        default: undefined
    }, 
    width: {
        type: [Number, String],
        default: undefined
    }, 
    size: {
        type: String,
        default: undefined
    }, 

    // Events
    close: {
        type: Function,
        default: undefined
    },  
    hide: {
        type: Function,
        default: undefined
    },  
    initOpen: {
        type: Function,
        default: undefined
    },  
    open: {
        type: Function,
        default: undefined
    },  
    show: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/DialogProps.js